import Vue from 'vue'
import _ from 'lodash'
import { User as Usr } from '@/types/_'
import { objectKeysToCamelCase } from '@/utils/common'

declare global {
  interface Window {
    API_FINX_AUTH: string;
  }
}

const defaultUser: Usr = {
  accessToken: '',
  expiresAt: '',
  idToken: '',
  profile: {
    authTime: '',
    email: '',
    emailVerified: [],
    name: '',
    preferredUsername: '',
    pageAuthorized: [],
    roles: [],
    sid: '',
    sub: '',
    defaultPage: {
      keyAuthorized: '',
      view: '',
    },
  },
  refreshToken: '',
  scope: '',
  sessionState: '',
  tokenType: '',
}

const item: any = localStorage.getItem(`oidc.user:${window.API_FINX_AUTH}:portal-client-2`)
const user: any = JSON.parse(item) ? objectKeysToCamelCase(JSON.parse(item)) : defaultUser
user.profile.emailVerified = user.profile.emailVerified || false

if (!user.profile.roles || Array.isArray(user.profile.roles)) {
  user.profile.roles = []
} else if (typeof user.profile.roles === 'string') {
  user.profile.roles = [user.profile.roles]
} else {
  user.profile.roles = Object.values(user.profile.roles)
}

if (!user.profile.pageAuthorized || Array.isArray(user.profile.pageAuthorized)) {
  user.profile.pageAuthorized = []
} else if (typeof user.profile.pageAuthorized === 'string') {
  user.profile.pageAuthorized = [user.profile.pageAuthorized]
} else {
  user.profile.pageAuthorized = Object.values(user.profile.pageAuthorized)
}

// Enable route '/ajuda' for doctors and secretaries...
if (
  user.profile.pageAuthorized
  && Array.isArray(user.profile.pageAuthorized)
  && (user.profile.pageAuthorized.includes('agendamento-medico') || user.profile.pageAuthorized.includes('agendamento-medico-ambulatorio'))
) {
  user.profile.pageAuthorized.push('ajuda')
}

const User = {
  install(options: any) {
    const defaultOptions = options
    Vue.prototype.$user = user
  },
}

export default User
